// extracted by mini-css-extract-plugin
module.exports =  {"input":"NpjZw9omuob2hR2tbhWg"};